import { CronInput, Form, useForm } from "@validereinc/common-components";
import { WorkflowTriggerScheduled } from "@validereinc/domain";
import classNames from "classnames/bind";
import React, { useEffect } from "react";
import {
  DEFAULT_CRON,
  useWorkflowConfigurationFormStore,
} from "../WorkflowConfigurationFormStore";
import styles from "./WorkflowConfigurationScheduledTriggerForm.module.scss";

const cx = classNames.bind(styles);

type WorkflowScheduledTriggerFormValues = Pick<
  WorkflowTriggerScheduled,
  "cron"
>;

const WorkflowScheduledTriggerForm = ({
  triggerDefinition,
}: {
  triggerDefinition?: WorkflowTriggerScheduled;
}) => {
  const { setTriggerCron, setTriggerCronIsValid, getTriggerCron } =
    useWorkflowConfigurationFormStore();

  const storeValues = getTriggerCron();

  const form = useForm<WorkflowScheduledTriggerFormValues>({
    defaultValues: {
      cron: triggerDefinition?.cron ?? DEFAULT_CRON,
    },
  });

  useEffect(() => {
    setTriggerCronIsValid(form.formState.isValid);
  }, [form.formState.isValid, setTriggerCronIsValid]);

  return (
    <Form
      className={cx("form")}
      {...form}
    >
      <div className={cx("repeat-container")}>
        <CronInput
          name="cron"
          isRequired
          label={"Repeats"}
          isLabelShown={true}
          onChange={(cron: string) => {
            if (storeValues) {
              setTriggerCron({
                ...storeValues,
                cron,
              });
            }
          }}
        />
      </div>
    </Form>
  );
};

export default WorkflowScheduledTriggerForm;
